import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { makeStyles } from "@material-ui/styles";
import FarmIcon from "components/icons/FarmIcon";
import TotalFarmIcon from "components/icons/TotalFarmIcon";
import React from "react";
import { NavLink } from "react-router-dom";
import FrequencyIcon from "assets/img/frequency-icon.png";
import DetailResultIcon from "components/icons/DetailResultIcon";
import AssessmentIcon from "components/icons/AssessmentIcon";

const ListItems = () => {
  const useStyles = makeStyles(() => ({
    link: {
      color: "#000",
      "&:hover":{
        color:'#000'
      }
    },
    activeLink: {
      color: "#F65C00",
      "&:hover":{
        color:'#F65C00'
      }
    },
  }));

  const classes = useStyles();
  return (
    <div>
      <NavLink
        to="/admin/farm"
        className={(props) =>
          props.isActive ? classes.activeLink : classes.link
        }
      >
        <ListItem button>
          <ListItemIcon>
            <FarmIcon />
          </ListItemIcon>
          <ListItemText primary="Danh sách trại" />
        </ListItem>
      </NavLink>
      <NavLink
        to="/admin/test-history"
        className={(props) =>
          props.isActive ? classes.activeLink : classes.link
        }
      >
        <ListItem button>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Lịch sử kiểm tra" />
        </ListItem>
      </NavLink>

      <NavLink
        to="/admin/total-farm"
        className={(props) =>
          props.isActive ? classes.activeLink : classes.link
        }
      >
        <ListItem button>
          <ListItemIcon>
            <TotalFarmIcon />
          </ListItemIcon>
          <ListItemText primary="Số lượng trại" />
        </ListItem>
      </NavLink>

      <NavLink
        to="/admin/frequency"
        className={(props) =>
          props.isActive ? classes.activeLink : classes.link
        }
      >
        <ListItem button>
          <ListItemIcon>
            <img src={FrequencyIcon} alt="" />
          </ListItemIcon>
          <ListItemText primary="Tần suất lặp lại" />
        </ListItem>
      </NavLink>

      <NavLink
        to="/admin/assessment"
        className={(props) =>
          props.isActive ? classes.activeLink : classes.link
        }
      >
        <ListItem button>
          <ListItemIcon>
            <AssessmentIcon />
          </ListItemIcon>
          <ListItemText primary="Hình thức đánh giá" />
        </ListItem>
      </NavLink>
      <NavLink
        to="/admin/detail-result"
        className={(props) =>
          props.isActive ? classes.activeLink : classes.link
        }
      >
        <ListItem button>
          <ListItemIcon>
            <DetailResultIcon />
          </ListItemIcon>
          <ListItemText primary="Kết quả chi tiết" />
        </ListItem>
      </NavLink>
    </div>
  );
};

export default ListItems;
